<app-view-title class="title-container" [title]="title"></app-view-title>

<div class="join-tenant-heading-container">
  @if (userData$ | async; as userData) {
    <div class="small-circle-user">{{ getInitials(userData.name) }}</div>
  }
  <div class="headline-6">{{ headline }}</div>
  <div class="body-2">Your email address lets you join these organizations, just select one from the list!</div>
</div>

@if (isUserFound$ | async) {
  <div class="table-container">
    <app-ag-toolbar-grid
      [columnDefs]="columnDefs"
      [dataProvider]="getSuggestedTenants.bind(this)"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      [noRowsOverlayMsg]="noRowsOverlayMessage"
      (rowSelected)="onRowSelected($event)"
      (sortChanged)="onSortChanged($event)"
      (filterChanged)="onFilterChanged($event)"
      (paginationChanged)="onPaginationChanged($event)"
    >
    </app-ag-toolbar-grid>
  </div>
}
<div class="footer-container button-group">
  <ra-ui-main-button id="join-org-btn" label="{{ continueText }}" [disabled]="!isOrgSelected" (click)="joinOrg()">
  </ra-ui-main-button>
  <ra-ui-outlined-button
    id="join-org-cancel-btn"
    label="{{ cancelText }}"
    (click)="cancelJoinOrg()"
  ></ra-ui-outlined-button>
</div>
